var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { base64url, CompactEncrypt, compactDecrypt, generateKeyPair, importJWK, exportJWK } from 'jose';
var Highline = /** @class */ (function () {
    function Highline() {
        this.urlPrefix = '';
    }
    /**
     * Retrieves Public key from Key Management API and sets publicKey instance variable
     * @method getPublicKey
     * @async
     * @param {string} productId - Product Id used by the Key management API
     * @returns void
     */
    Highline.prototype.getPublicKey = function (productId) {
        return __awaiter(this, void 0, void 0, function () {
            var dxgwKeyResponse, dxgwKeyJson, newJWKPublicKey, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.debug('[HLSERVICE] ---- Getting key from DXGW ----');
                        return [4 /*yield*/, fetch("".concat(this.urlPrefix, "/developer-platform/key-management/certificates/keys?productId=").concat(productId), {
                                method: "GET",
                                headers: {
                                    'Content-Type': 'application/json;v=1',
                                    'Accept': 'application/json;v=1'
                                }
                            })];
                    case 1:
                        dxgwKeyResponse = _b.sent();
                        return [4 /*yield*/, dxgwKeyResponse.json()];
                    case 2:
                        dxgwKeyJson = _b.sent();
                        console.debug('[HLSERVICE] Response from DXGW', dxgwKeyJson);
                        newJWKPublicKey = dxgwKeyJson['keys'][0];
                        console.debug('[HLSERVICE] Setting Highline public key to', newJWKPublicKey);
                        _a = this;
                        return [4 /*yield*/, importJWK(newJWKPublicKey, 'ECDH-ES')];
                    case 3:
                        _a.publicKey = (_b.sent());
                        console.debug('[HLSERVICE] Setting Highline kid to ', newJWKPublicKey.kid);
                        this.kid = newJWKPublicKey.kid;
                        this.exp = newJWKPublicKey.exp;
                        console.debug("[HLSERVICE] This key will expire on ".concat(new Date(this.exp * 1000).toLocaleString()));
                        this.productId = productId;
                        return [2 /*return*/];
                }
            });
        });
    };
    Highline.prototype.encryptWithPublicKey = function (sensitiveData) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.debug('[HLSERVICE] ---- Encrypting ----');
                        console.debug('[HLSERVICE] Verifying key expiry before encrypting...');
                        if (!this.isPublicKeyExp()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getPublicKey(this.productId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        console.debug('[HLSERVICE] public key: ', this.publicKey);
                        if (!this.publicKey) return [3 /*break*/, 4];
                        return [4 /*yield*/, new CompactEncrypt(new TextEncoder().encode(sensitiveData))
                                .setProtectedHeader({
                                alg: 'ECDH-ES',
                                enc: 'A256GCM',
                                kid: this.kid
                            })
                                .encrypt(this.publicKey)];
                    case 3:
                        result = _a.sent();
                        console.debug(' [HLSERVICE] result: ', result);
                        console.debug('result', result.toString());
                        return [2 /*return*/, result];
                    case 4:
                        console.warn('[HLSERVICE] Public key was not set, returning undefined.');
                        return [2 /*return*/, undefined];
                }
            });
        });
    };
    Highline.prototype.isPublicKeyExp = function () {
        var today = new Date();
        var expDate = new Date(this.exp * 1000);
        if (today > expDate) {
            console.warn("Current public key is expired.");
            return true;
        }
        console.debug("Current public key is not expired. It will expire on ".concat(expDate.toLocaleString()));
        return false;
    };
    Highline.prototype.decryptWithPrivateKey = function (cypherText, key, encoding) {
        if (encoding === void 0) { encoding = 'utf8'; }
        return __awaiter(this, void 0, void 0, function () {
            var decryptResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.debug('[HLSERVICE] ---- Decrypting ----');
                        return [4 /*yield*/, compactDecrypt(cypherText, key)];
                    case 1:
                        decryptResult = _a.sent();
                        return [2 /*return*/, new TextDecoder(encoding).decode(decryptResult.plaintext)];
                }
            });
        });
    };
    Highline.prototype.generateEphemeralKeyPair = function (curve, jweOptions) {
        if (jweOptions === void 0) { jweOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.debug('[HLSERVICE] ---- Generating Key Pair ----');
                        return [4 /*yield*/, generateKeyPair('ECDH-ES', __assign({ crv: curve }, jweOptions))];
                    case 1:
                        key = _a.sent();
                        console.debug('[HLSERVICE] Setting highline public key to ', key.publicKey);
                        this.publicKey = key.publicKey;
                        return [2 /*return*/, key];
                }
            });
        });
    };
    Highline.prototype.getPublicJWKFromEphemeralKeyPair = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.debug('[HLSERVICE] Exporting JWK from ephemeral key pair');
                return [2 /*return*/, exportJWK(key.publicKey)];
            });
        });
    };
    Highline.prototype.base64UrlEncode = function (str) {
        return base64url.encode(str);
    };
    Highline.prototype.base64UrlDecode = function (str) {
        var buffer = base64url.decode(str);
        return String.fromCharCode.apply(null, buffer);
    };
    Highline.prototype.expandJWE = function (jweToken) {
        var tokenSplit = jweToken.split('.');
        if (tokenSplit.length !== 5) {
            console.error("Not a valid compact JWE", tokenSplit);
            return null;
        }
        return {
            protected: tokenSplit[0],
            encrypted_key: tokenSplit[1],
            iv: tokenSplit[2],
            ciphertext: tokenSplit[3],
            tag: tokenSplit[4]
        };
    };
    return Highline;
}());
export var CURVE;
(function (CURVE) {
    CURVE["P_256"] = "P-256";
    CURVE["P_384"] = "P-384";
    CURVE["P_521"] = "P-521";
})(CURVE || (CURVE = {}));
export { Highline };
